module.exports = __webpack_public_path__ + "static/img/1.3d3e174.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/sp/1.png
// module id = ETYE
// module chunks = 0